import {getLatLongFromAddress} from "../../../../slices/leads/api/lead-management-api";

export   function mapGoogleAddressToAddressOne(addressObject: any) {
    let addressOne;
    if (addressObject.length === 7){
        addressOne = {
            addressLineOne: addressObject[0]?.value || '',
            addressLineTwo: addressObject[1]?.value +" "+ addressObject[2]?.value +" "+addressObject[3]?.value|| '',
            city: addressObject[4]?.value || '',
            state: addressObject[5]?.value || '',
            country: addressObject[6]?.value || '',
        };
    }else if (addressObject.length === 6){
        addressOne = {
            addressLineOne: addressObject[0]?.value || '',
            addressLineTwo: addressObject[1]?.value +" "+ addressObject[2]?.value || '',
            city: addressObject[3]?.value || '',
            state: addressObject[4]?.value || '',
            country: addressObject[5]?.value || '',
        };
    }else if (addressObject.length === 5){
        addressOne = {
            addressLineOne: addressObject[0]?.value || '',
            addressLineTwo: addressObject[1]?.value  || '',
            city: addressObject[2]?.value || '',
            state: addressObject[3]?.value || '',
            country: addressObject[4]?.value || '',
        };
    }else if (addressObject.length === 4){
        addressOne = {
            addressLineOne:addressObject[0]?.value,
            addressLineTwo:addressObject[1]?.value,
            city:addressObject[2]?.value,
            state:'',
            country: addressObject[3]?.value,
        };
    }else if (addressObject.length === 3){
        addressOne = {
            addressLineOne:'',
            addressLineTwo:'',
            city:addressObject[0]?.value,
            state:addressObject[1]?.value,
            country:addressObject[2]?.value,
        };
    }else if (addressObject.length === 2){
        addressOne = {
            addressLineOne:'',
            addressLineTwo:'',
            city:'',
            state:addressObject[0]?.value,
            country:addressObject[1]?.value,
        };
    }else if (addressObject.length === 1){
        addressOne = {
            addressLineOne:'',
            addressLineTwo:'',
            city:'',
            state:'',
            country:addressObject[0]?.value,
        };
    }
    return addressOne;
}

export const accessLocation = async (result: string, setOrigin: any, setDestination:any) => {
  const location = await getLatLongFromAddress(result);
  
  setOrigin(location);
  //set current location
  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setDestination({ lat: latitude, lng: longitude })
      },
      (error: any) => {
        setDestination(
          {lat: -37.8178636, lng: 144.9653084});
        console.error(`Error getting location: ${error.message}`);
        switch (error.code) {
          case error.PERMISSION_DENIED:
            console.error("User denied the request for Geolocation.");
            break;
          case error.POSITION_UNAVAILABLE:
            console.error("Location information is unavailable.");
            break;
          case error.TIMEOUT:
            console.error("The request to get user location timed out.");
            break;
          case error?.UNKNOWN_ERROR:
            console.error("An unknown error occurred.");
            break;
          default:
            console.error("An error occurred.");
        }
      }
    );
  } else {
    // Geolocation is not available
  }

}